module.exports = __webpack_public_path__ + "img/clock-three-thirty.2e00b078.svg";